import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class PwdVerifyModal extends Vue {

    @Prop()
    isPwdVerifyModal!: boolean

    private password: string | null = null;
    private showPassword = false;
    private isLoading = false;

    @Watch('isPwdVerifyModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
        if (!val) {
            this.resetForm();
        }
    }

    verify(): void {
        if (this.isLoading) {
            return;
        }
        if (!this.password) {
            window.alert('パスワードを入力してください。');
            return;
        }
        this.isLoading = true;
        this.$apiClient.doRequest('post', '/pwd_settings/verify', { password: this.password }).then((res: any) => {
            if (res.result) {
                this.resetForm();
                this.$emit('verified');
            } else {
                window.alert('パスワードが正しくありません。');
            }
        }).finally(() => {
            this.isLoading = false;
        });
    }

    closeModal(): void {
        this.resetForm();
        this.$emit('update:isPwdVerifyModal', false);
    }

    private resetForm(): void {
        this.password = null;
        this.showPassword = false;
    }
}
